export const areArraysEqual = (arr1: any[], arr2: any[]): boolean => {
  if (arr1.length !== arr2.length) return false;

  const ids1 = arr1.map(item => item.id).sort();
  const ids2 = arr2.map(item => item.id).sort();

  return ids1.every((id, index) => id === ids2[index]);
};

export const sortByLabel = (a: { labelContent: string }, b: { labelContent: string }): number => a.labelContent.localeCompare(b.labelContent);

export const haveSameIds = (arr1: { id: string }[], arr2: { id: string }[]): boolean => {
  if (arr1.length !== arr2.length) return false;
  const ids = new Set(arr1.map(item => item.id));
  return arr2.every(item => ids.has(item.id));
};
